import { render, staticRenderFns } from "./changephone.vue?vue&type=template&id=23abaed6&"
import script from "./changephone.vue?vue&type=script&lang=js&"
export * from "./changephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports